import {
  AppsActionTypes,
  ADD_APPS,
  DELETE_APPS,
  UPDATE_APPS,
  SELECTED_ORG,
  REMOVE_SELECTED_ORG,
  UPDATE_APP_VERSION,
  UPDATE_APP_LIST,
  UPDATE_SELECTED_APP,
  UPDATE_APP_BRANCH,
  UPDATE_SELECTED_BPMN,
  UPDATE_SELECTED_DMN,
  FORM_VERSION,
  FORM_CORE_VERSION,
  UPDATE_SELECTED_AGENT_NAME
} from "./types";

export function createApps(data: any): AppsActionTypes {
  return {
    type: ADD_APPS,
    data: data
  };
}

export function deleteApps(data: any): AppsActionTypes {
  return {
    type: DELETE_APPS,
    data: data
  };
}

export function updateApps(data: any): AppsActionTypes {
  return {
    type: UPDATE_APPS,
    data: data
  };
}

export function selectedOrg(data: any): AppsActionTypes {
  return {
    type: SELECTED_ORG,
    data: data
  };
}

export function removeSelectedOrg(): AppsActionTypes {
  return {
    type: REMOVE_SELECTED_ORG,
    data: ""
  };
}

export function updateAppVersion(data: { key: string, value: any }): AppsActionTypes {
  return {
    type: UPDATE_APP_VERSION,
    data: data
  }
}

export function updateAppBranch(data: { key: string, value: any }): AppsActionTypes {
  return {
    type: UPDATE_APP_BRANCH,
    data: data
  }
}

export function updateSelectedApp(data: any): AppsActionTypes {
  return {
    type: UPDATE_SELECTED_APP,
    data: data
  }
}
export function updateSelectedBpmn(data: any): AppsActionTypes {
  return {
    type: UPDATE_SELECTED_BPMN,
    data: data
  }
}

export function selectedDmn(data: any): AppsActionTypes {
  return {
    type: UPDATE_SELECTED_DMN,
    data: data
  }
}

export function updateAppsList(data: any): AppsActionTypes {
  return {
    type: UPDATE_APP_LIST,
    data: data
  }
}
export function updateFormVersion(data: any): AppsActionTypes {
  return {
    type: FORM_VERSION,
    data: data
  }
}

export function updateFormCoreVersion(data: any): AppsActionTypes {
  return {
    type: FORM_CORE_VERSION,
    data: data
  }
}

export function updateAgentName(data: any): AppsActionTypes {
  return {
    type: UPDATE_SELECTED_AGENT_NAME,
    data: data
  }
}